import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useFlexPuffEnabled = (iotDevice) => {
    const isEnabledGlobally = iotDeviceGlobalConfigService.isGlobalFlexPuff(iotDevice);
    const isFeatureEnabled = iotDeviceFeatureConfigService.isFlexPuffEnabled();
    const isEnabled = iotDeviceSettingsService.isSettingAvailable(iotDevice, isEnabledGlobally, isFeatureEnabled);

    return isEnabled;
};

export default useFlexPuffEnabled;
